// Site content. Edit here to change copy, projects or imagery —
// nothing else needs touching.

export const profile = {
  // Pairs with `monogram` in the navbar, which supplies the leading "S".
  name: "McLaughlin Design",
  role: "Brand & Visual Designer",
  // Shown only in the footer's "Studio" block.
  location: "Smithtown, NY",
  email: "sebastian.maclaughlin@gmail.com",
  monogram: "S",
  heroLine: "Designing bold, considered brands that people remember.",
  heroSub:
    "I craft identity systems, print and digital experiences for ambitious people and companies. Currently open to new opportunities.",
  disciplines: [
    "Brand Identity",
    "Logo Design",
    "Print & Editorial",
    "Illustration",
    "Art Direction",
    "Packaging",
  ],
};

export const categories = ["All", "Branding", "Digital", "Logo", "Print", "Illustration"];

export const projects = [
  // Titles, clients, years and summaries lifted from smclaughlindesign.com.
  // All imagery is Sebastian's own work; full-res originals live in /assets-source.
  {
    id: "fourleaf",
    title: "FourLeaf Federal Credit Union",
    category: "Digital",
    year: "2024\u201326",
    client: "FourLeaf Federal Credit Union",
    role: "Social Graphics, Web Banners, Campaign Collateral",
    fit: "contain",
    cover: "/images/fourleaf-einstein-learning-center.jpg",
    summary:
      "In-house marketing design for FourLeaf Federal Credit Union, formerly Bethpage Federal Credit Union, working inside a rebranded identity system. Web banners and social graphics for branch openings, rate promotions and mortgage campaigns, alongside co-branded artwork for the community partnerships the credit union sponsors \u2014 the Northwell Health Walk, Girl Scouts of Suffolk County and the Katz Institute for Women\u2019s Health.",
    gallery: [
      "/images/fourleaf-jackson-heights-rates.jpg",
      "/images/fourleaf-bonus-offer.jpg",
      "/images/fourleaf-mortgage-banner.jpg",
      "/images/fourleaf-einstein-learning-center.jpg",
      "/images/fourleaf-northwell-webinar.jpg",
      "/images/fourleaf-girl-scouts-light-show.jpg",
    ],
  },
  {
    id: "long-island-museum",
    title: "Long Island Museum",
    category: "Print",
    year: "2022/23",
    client: "Long Island Museum",
    role: "Event Invitations, Brochure Design",
    fit: "contain",
    cover: "/images/lim-postcard.jpg",
    summary:
      "Print and direct-mail design for the Long Island Museum: exhibition invitations for the 2023 season and the 9th Annual LIMarts Members\u2019 Exhibition, a save-the-date for the museum\u2019s 25th Annual Golf Tournament, and the Summer 2023 Events Calendar \u2014 a folded brochure carrying three months of programmes, exhibitions and listings across a tight editorial grid.",
    gallery: [
      "/images/lim-postcard.jpg",
      "/images/lim-2023-exhibitions.jpg",
      "/images/lim-golf-save-the-date.jpg",
      "/images/lim-calendar-01.jpg",
      "/images/lim-calendar-02.jpg",
    ],
  },
  {
    id: "lindros-travel",
    title: "Lindros Travel",
    category: "Logo",
    year: "",
    client: "Lindros Travel",
    role: "Primary Logo, Sub-brand Logo, Collateral",
    fit: "contain",
    blend: true,
    cover: "/images/lindros-logo.jpg",
    summary:
      "Lindros Travel, based in North Carolina, creates scuba diving and luxury travel experiences for everyone from first-time divers to seasoned adventurers. A new visual identity capturing the spirit of luxury adventure travel: a primary lighthouse-and-ship's-wheel mark, a \u201cScuba Scott Recommends\u201d sub-brand lockup, and promotional stickers.",
    gallery: [
      "/images/lindros-logo.jpg",
      "/images/lindros-scuba-scott-logo.jpg",
      "/images/lindros-sticker.png",
      "/images/lindros-sticker-qr.png",
    ],
  },
  {
    id: "inishtrahull-whiskey",
    title: "Inishtrahull Irish Whiskey",
    category: "Branding",
    year: "2018",
    client: "Self-initiated",
    role: "Brand Concept, Brand Story, Product Design",
    cover: "/images/inishtrahull-04.jpg",
    summary:
      "Concept and creation of a whiskey brand from the ground up \u2014 a modern, elegant identity built on an original brand story: a young Derry blacksmith setting sail for America in 1929, taking a drink as he passed the Inishtrahull Lighthouse, his last sight of Ireland. The lighthouse became the mark, and runs through bottle and label, carton, gift box, coasters, bag and merchandise.",
    gallery: [
      "/images/inishtrahull-01.jpg",
      "/images/inishtrahull-02.jpg",
      "/images/inishtrahull-03.jpg",
      "/images/inishtrahull-04.jpg",
      "/images/inishtrahull-05.jpg",
      "/images/inishtrahull-06.jpg",
      "/images/inishtrahull-07.jpg",
    ],
  },
  {
    id: "all-folkd-up",
    title: "All Folk\u2019d Up",
    category: "Logo",
    year: "",
    client: "All Folk\u2019d Up",
    role: "Logo Redesign, Visual Identity",
    fit: "contain",
    blend: true,
    cover: "/images/all-folkd-up-logo.jpg",
    summary:
      "A logo redesign for the contemporary Irish folk-rock band All Folk\u2019d Up, who rework traditional Irish songs with a modern, up-tempo twist. The crest quarters the band in four marks \u2014 a banjo for the trad backbone, a shamrock, a clasped handshake remembering a bandmate whose life was cut short, and a pint they raise to him. Carried through onto band merchandise.",
    gallery: [
      "/images/all-folkd-up-logo.jpg",
    ],
  },
  {
    id: "obriens",
    title: "O\u2019Brien\u2019s Irish Pub, Times Square",
    category: "Print",
    year: "2017",
    client: "O\u2019Brien\u2019s Irish Pub",
    role: "Brochure, Poster & Menu Design, Illustration",
    cover: "/images/obriens-flyer.jpg",
    summary:
      "A busy Irish pub and restaurant in the heart of Times Square with live music every night, looking to revamp its weekly entertainment ads and redesign its menus and posters. The bi-fold brochure carries the 46th Street storefront on the cover, the week\u2019s live music and sports listings on the back, and the full food and drinks menu inside, set on a Celtic-knot watermark in the house green and gold. Alongside it, a nightly entertainment poster built on an original hand-drawn illustration of the pub front, and a summer menu poster with illustrated produce.",
    gallery: [
      "/images/obriens-flyer.jpg",
      "/images/obriens-brochure-outside.jpg",
      "/images/obriens-outside.jpg",
      "/images/obriens-inside.jpg",
      "/images/obriens-entertainment-poster.jpg",
      "/images/obriens-summer-salad-poster.jpg",
    ],
  },
  {
    id: "irishtown",
    title: "Irishtown",
    category: "Illustration",
    year: "2017",
    client: "Eamon Loingsigh",
    role: "Character Design, Digital Illustration",
    cover: "/images/irishtown-01.jpg",
    summary:
      "A web series based on Eamon Loingsigh\u2019s books \u201cLight of the Diddicoy\u201d and \u201cExile on Bridge Street,\u201d following Irish gangsters in 1910s Brooklyn through the eyes of William \u201cLiam\u201d Garrity of the White Hand gang. Character design and development across the full cast \u2014 dockworkers, gang bosses, women of the neighbourhood and the boys running errands between them \u2014 drawn in tonal greyscale with costume turnarounds and paired scene studies.",
    gallery: [
      "/images/irishtown-01.jpg",
      "/images/irishtown-02.jpg",
      "/images/irishtown-03.jpg",
      "/images/irishtown-04.jpg",
      "/images/irishtown-05.jpg",
      "/images/irishtown-06.jpg",
      "/images/irishtown-07.jpg",
      "/images/irishtown-08.jpg",
      "/images/irishtown-09.jpg",
      "/images/irishtown-10.jpg",
      "/images/irishtown-11.jpg",
      "/images/irishtown-12.jpg",
      "/images/irishtown-13.jpg",
    ],
  },
  {
    id: "album-cover-art",
    title: "Album Cover Art",
    category: "Illustration",
    year: "2016",
    client: "Sean McNally",
    role: "Album Artwork, Illustration",
    fit: "contain",
    cover: "/images/album-front.jpg",
    summary:
      "Original digital illustration artwork for the cover, inside and CD of singer-songwriter Sean McNally\u2019s debut album, \u201cBefore I Kick the Can.\u201d Hand-drawn pen-and-ink scenes \u2014 a room of instruments, a moonlit Brooklyn alley \u2014 printed on warm uncoated stock.",
    gallery: [
      "/images/album-front.jpg",
      "/images/album-inside.jpg",
    ],
  },
  {
    id: "hands-tulips",
    title: "Irish Baby Sign Language Book",
    category: "Illustration",
    year: "2015",
    client: "Hands Tulips",
    role: "Character Design, Illustration, Typography, Layout",
    fit: "contain",
    cover: "/images/hands-tulips-01.jpg",
    summary:
      "Original character design, illustration, typography and layout for an Irish baby sign language book. Each spread pairs a hand-drawn child demonstrating the sign with a plain-language note on how to make it \u2014 again, all gone, thank you, sleep, love, please \u2014 so a parent and child can read it together.",
    gallery: [
      "/images/hands-tulips-01.jpg",
    ],
  },
];

export const services = [
  {
    number: "01",
    title: "Brand Identity",
    description:
      "Complete identity systems \u2014 strategy, logo, typography, colour and guidelines that give your brand a clear, lasting voice.",
  },
  {
    number: "02",
    title: "Logo Design",
    description:
      "Distinctive, versatile marks and monograms crafted to work beautifully across every size and application.",
  },
  {
    number: "03",
    title: "Print & Editorial",
    description:
      "Books, magazines, packaging and collateral with a refined typographic system and considered print finishes.",
  },
  {
    number: "04",
    title: "Illustration",
    description:
      "Custom illustration and art direction that adds warmth, personality and a hand-made touch to your brand.",
  },
];

export const about = {
  portrait:
    "/images/portrait.jpg",
  paragraphs: [
    "I'm a multidisciplinary designer helping brands look and feel their best. My work spans identity, print and illustration, always led by a shared commitment to quality and care.",
  ],
  skills: [
    "Brand Strategy",
    "Identity Design",
    "Typography",
    "Art Direction",
    "Illustration",
    "Packaging",
    "Adobe CC",
    "Figma",
  ],
};

export const testimonials = [
  {
    quote:
      "Delivered a high quality design for album cover art as well as insert art. Great communication throughout the project. Incorporated changes quickly. Highly recommend.",
    name: "Sean McNally",
    title: "Musician",
  },
  {
    quote:
      "Great working on band merchandise designs and logos. I found the work to be excellent and delivered in a timely manner. Highly recommend!",
    name: "Matthew Jordan",
    title: "Rising PR",
  },
  {
    quote:
      "Really great to work with. Super flexible with my project's needs and really helped me reach a larger audience.",
    name: "Eamon Loingsigh",
    title: "Author, Art of Need",
  },
];

export const socials = [
  { label: "LinkedIn", href: "https://www.linkedin.com/in/sebmclaughlin/" },
];
